/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 11:55:29
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-19 11:08:33
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\store\research\mutations.js
 */
import * as MUTATIONTYPES from '../mutationTypes'
import * as STATETYPES from '../stateTypes'
const mutations = {
	[MUTATIONTYPES.SETRESEARCHINFO](state, { researchName, researchCode, info }) {
		state[STATETYPES.RESEARCHINFO] = info
		state[STATETYPES.RESEARCHNAME] = researchName
		state[STATETYPES.RESEARCHCODE] = researchCode
	}
}
export default mutations